const NAME = "WALLET";

export const UPDATE_MOS_BALANCE = `${NAME}/UPDATE_MOS_BALANCE`;
export const UPDATE_MOS_BALANCE_SUCCESS = `${NAME}/UPDATE_MOS_BALANCE_SUCCESS`;
export const UPDATE_MOS_BALANCE_FAILED = `${NAME}/UPDATE_MOS_BALANCE_FAILED`;
export const RESET_MOS_BALANCE = `${NAME}/RESET_MOS_BALANCE`;

export const mosBalanceData = (store) => store[NAME].mosBalance;
